import { MultiSelect } from '@/presentation/components/multi-select'
import type { AutoFormWidgetsProps } from '../autoForm'
import { Field } from '../field'
import { FieldControl } from '../fieldControl'
import { FieldLabel } from '../label'
import { FieldMessage } from '../message'

type SelectItemValue = {
  value: string
  label: string
}

export const MultiSelectWidget = (props: AutoFormWidgetsProps) => {
  return (
    <Field path={props.path} className={props.classNames?.root}>
      <FieldLabel>{props.options?.label as string}</FieldLabel>

      <FieldControl>
        <MultiSelect
          options={props.options?.values as SelectItemValue[]}
          onValueChange={() => {}}
          defaultValue={
            typeof props.initialValue === 'string' ? [props.initialValue] : props.initialValue
          }
          placeholder={props.options?.placeholder as string}
          variant="inverted"
          className="bg-white"
          maxCount={4}
          modalPopover={true}
        />
      </FieldControl>
      <FieldMessage />
    </Field>
  )
}
